// How a client's data source is presented (badges on Home, sidebar, admin).
const SOURCE_TYPES = {
  slack: { label: 'Slack', tone: 'violet' },
  band: { label: 'Band', tone: 'green' },
};

export const sourceLabel = (type) => SOURCE_TYPES[type]?.label || 'Source externe';

export const sourceTone = (type) => SOURCE_TYPES[type]?.tone || 'gray';

/**
 * Slack stamps messages in seconds ("1726405200.000100"), Band in milliseconds (1726405200000).
 * Anything below 1e12 is read as seconds.
 */
export const messageDate = (ts) => {
  const value = typeof ts === 'number' ? ts : parseFloat(ts);
  if (!Number.isFinite(value) || value <= 0) return null;
  return new Date(value < 1e12 ? value * 1000 : value);
};

/** Band dumps store everything under main/posts: name it for humans. */
export const channelLabel = (channel) => (channel === 'posts' ? 'Publications' : channel);
